module.exports = __webpack_public_path__ + "static/img/hansen-logo.455a5bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hansen-logo.png
// module id = GczD
// module chunks = 2